import { createElement, forwardRef } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import invariant from 'invariant';
import useWishlists from 'Hooks/useWishlists';

export default function withWishlist(Component) {
  const displayName = `withWishlist(${ (Component.displayName || Component.name || 'Component') })`;

  const WithWishlists = forwardRef((props, ref) => {
    const wishlistContext = useWishlists();
    invariant(
      wishlistContext,
      `You should not use <${displayName} /> outside a <WishlistProvider />`
    );
    return createElement(Component, {
      wishlistContext,
      ref,
      ...props
    });
  });

  WithWishlists.displayName = displayName;
  WithWishlists.WrappedComponent = Component;

  return hoistNonReactStatics(WithWishlists, Component);
}
